export default {
  data() {
    return {
      validationServeur: true,
    }
  },
  methods: {
    serveurRule(field) {
      return () => {
        if (this.validationServeur && this.errors) {
          const error = this.errors.fields[field]
          if (error) {
            return error.map((e) => e.defaultMessage).join(', ')
          }
        }
        return true
      }
    },
  },
}
